import create from 'zustand';

type ReviewPanelStore = {
  isOpen: boolean;
  // Websocket id of the run in flight, per journey. Only an accelerator (the poll
  // is authoritative), but held here so it survives the panel unmounting.
  runWebsocketIdByJourney: Record<string, string>;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setRunWebsocketId: (journeyShortId: string, websocketId: string) => void;
  clearRunWebsocketId: (journeyShortId: string) => void;
  startExternalRun: (journeyShortId: string, websocketId: string) => void;
};

export const useReviewPanelStore = create<ReviewPanelStore>((set) => ({
  isOpen: false,
  runWebsocketIdByJourney: {},
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setRunWebsocketId: (journeyShortId, websocketId) =>
    set((state) => ({
      runWebsocketIdByJourney: {
        ...state.runWebsocketIdByJourney,
        [journeyShortId]: websocketId,
      },
    })),
  clearRunWebsocketId: (journeyShortId) =>
    set((state) => {
      if (!(journeyShortId in state.runWebsocketIdByJourney)) return state;
      const next = { ...state.runWebsocketIdByJourney };
      delete next[journeyShortId];
      return { runWebsocketIdByJourney: next };
    }),
  startExternalRun: (journeyShortId, websocketId) =>
    set((state) => ({
      isOpen: true,
      runWebsocketIdByJourney: {
        ...state.runWebsocketIdByJourney,
        [journeyShortId]: websocketId,
      },
    })),
}));
